import { useAuth0 } from '@auth0/auth0-react';

import { routes } from '~/shared/config/routes';
import { useAuthStore, UserRole } from '~/shared/model/auth';

export function useLogin() {
  const { loginWithPopup: auth0Login, getAccessTokenSilently } = useAuth0();

  const login = useAuthStore((state) => state.login);

  const handleLogin = async ({ role }: { role: UserRole }) => {
    await auth0Login({
      appState: {
        returnTo: routes.home.get(),
      },
      authorizationParams: {
        prompt: 'login',
      },
    });

    const token = await getAccessTokenSilently();

    login(token, { role, _source: 'after_logging_in' });
  };

  return { handleLogin };
}
